import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import store from './store';
import MapView from './components/map/MapView';

// ---------------------------------------------------------------------------
// Dark telecom theme
// ---------------------------------------------------------------------------
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary:    { main: '#1565C0' },
    secondary:  { main: '#FF6B35' },
    background: { default: '#0A1929', paper: '#0D1B2A' },
  },
  typography: {
    fontFamily: '"IBM Plex Mono", "Roboto Mono", monospace',
  },
  shape: { borderRadius: 8 },
});

// ---------------------------------------------------------------------------
// App
// ---------------------------------------------------------------------------
const App = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{
        width: '100%', height: '100%',
        display: 'flex', flexDirection: 'column',
        backgroundColor: '#0A1929',
      }}>
        <MapView />
      </Box>
    </ThemeProvider>
  </Provider>
);

export default App;